import { BrowserLocalStorage } from "@shopify/web-pixels-extension/build/ts/types/PixelEvents";

export const setLocalStorageWithExpiry = (
  key: string,
  value: any,
  numHours: number,
  localStorage: BrowserLocalStorage,
) => {
  const ttl = 60 * 60 * 1000 * numHours;
  const now = new Date();
  const item = { value, expiry: now.getTime() + ttl };
  void localStorage.setItem(key, JSON.stringify(item));
};

export const getLocalStorageWithExpiry = async (
  key: string,
  localStorage: BrowserLocalStorage,
) => {
  const itemStr = await localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    return null;
  }
  return item.value;
};
